module.exports = __webpack_public_path__ + "static/training5-2a4bc2373d23af141c510d00e1f1e007.jpg";